import { isBrowser } from '../is-browser.mjs';
import { hasReducedMotionListener, prefersReducedMotion } from './state.mjs';
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser) return;
  if (window.matchMedia) {
    var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    var setReducedMotionPreferences = function setReducedMotionPreferences() {
      return prefersReducedMotion.current = motionMediaQuery.matches;
    };
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}
export { initPrefersReducedMotion };